import {Component, OnInit, TemplateRef, ViewChild} from '@angular/core';
import {NgbModal, NgbModalOptions} from "@ng-bootstrap/ng-bootstrap";
import {AjoutProjetComponent} from "./ajout-projet/ajout-projet.component";
import Swal from 'sweetalert2';
import {ProjetService} from "../../../services/projet.service";
import {GlobalConfig, ToastrService} from "ngx-toastr";
import {ActivatedRoute} from "@angular/router";
@Component({
  selector: 'app-project-parametre',
  templateUrl: './project-parametre.component.html',
  styleUrls: ['./project-parametre.component.scss']
})
export class ProjectParametreComponent implements OnInit {
  private options: GlobalConfig;
  @ViewChild('ajout') ajoutComponent!: AjoutProjetComponent;


  constructor(private toastr: ToastrService, private modalService: NgbModal, private projetService: ProjetService) {
    this.options = this.toastr.toastrConfig;
  }
  projects: any[] = [];
 // stationId!: number;

  currentUser = JSON.parse(localStorage.getItem('currentUser'));

  clientId = this.currentUser?.id;
  stationId = this.currentUser?.stations?.[0]?.id;
 public modalRef: any;

  selectedProject: any | null = null;
  pendingStatus: boolean = false;

  error: string | null = null;
  isLoading = false;
  data: any = {
    id: 0,
    client_id: 0,
    station_id: 0,
    libelle: '',
    status: '',
  };

  dataError : {
    libelle: string;
    status: string;
  }

  ngOnInit(): void {


      console.log('Client ID:', this.clientId);
      console.log('Station ID:', this.stationId);
    this.loadProjects();
  }


  openAjoutModal() {
      this.ajoutComponent.projectData = null;
    this.ajoutComponent.openModal();
  }

    openEditModal(project: any) {
        this.ajoutComponent.projectData = project;
        this.ajoutComponent.openModal();
    }

  loadProjects(): void {
    this.projetService.getProjectsByIdStation(this.stationId).subscribe({
      next: (projects) => {
        this.projects = projects;
       // console.log(projects);
      },
      error: (err) => {
        this.toastr.error('Erreur lors du chargement des projets');
      }
    });
  }

  toggleStatus(project: any): void {
    const newStatus = !project.statut;

    this.projetService
        .toggleProjectStatus(project.station_id, project.id, newStatus)
        .subscribe({
          next: () => {
            project.statut = newStatus; // update UI immediately on success
          },
          error: (err) => {
              this.toastr.error('Erreur lors de la mise à jour du statut du projet');
          }
        });
  }



  ConfirmTextOpen() {
    Swal.fire({
      title: 'Désactivation projet ',
      text: " Êtes-vous sûr de vouloir désactiver le projet X ? ",
      showCancelButton: true,
      confirmButtonColor: '#134AD3',
      cancelButtonColor: 'rgba(85,88,92,0.16)',
      confirmButtonText: 'Confirmer',
      cancelButtonText: 'Annuler',
      customClass: {
        confirmButton: 'btn btn-primary',
        cancelButton: 'btn ml-1'
      }
    }).then(function (result) {
      if (result.value) {
        Swal.fire({
          icon: 'success',
          title: 'Deleted!',
          text: 'Your file has been deleted.',
          customClass: {
            confirmButton: 'btn btn-success'
          }
        });
      }
    });
  }
  openArchiveModal(content: TemplateRef<any>, project: any) {
    this.selectedProject = project;
    this.pendingStatus = !project.statut;
    this.modalService.open(content,  { centered: true });
  }




  confirmStatusChange(modal: any): void {
    if (!this.selectedProject) return;

    const {station_id, id} = this.selectedProject;

    this.projetService.toggleProjectStatus(station_id, id, this.pendingStatus).subscribe({
      next: () => {

        this.selectedProject!.statut = this.pendingStatus;
        modal.close();
        this.selectedProject = null;
          this.toastr.success('Modification du status enregistrée avec succès !', '', {
              positionClass: 'toast-bottom-right',
              toastClass: 'toast ngx-toastr custom-success-toast',
          });
      },
      error: (err) => {
          this.toastr.error('Erreur de mise à jour du statut');
      }
    });

  }

  onProjectSaved() {
    this.loadProjects();
  }



}
